module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp1_3016.2bc92268.png";